module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Cb-Db-Ec-Fb-Gb.0fa1ee50.png";